import {
  Error,
  ADD_Department,
  UPDATE_Department,
  DELETE_Department,
  GET_Department,
} from "../type";
const initialState = {
  AddDepartment: [],
  GetDepartment: [],
  UpdateDepartment: [],
  DeleteDepartment: [],
};
const DepartmentR = (state = initialState, action) => {
  switch (action.type) {
    case GET_Department:
      return {
        ...state,
        GetDepartment: action.payload,
      };
    case ADD_Department:
      return {
        GetDepartment: state.GetDepartment,
        AddDepartment: action.payload,
      };
    case UPDATE_Department:
      return {
        GetDepartment: state.GetDepartment,
        UpdateDepartment: action.payload,
      };
    case DELETE_Department:
      return {
        GetDepartment: state.GetDepartment,
        DeleteDepartment: action.payload,
      };
    case Error:
      return {
        GetDepartment: action.payload,
      };
    default:
      return state;
  }
};
export default DepartmentR;
